import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CaretDownIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 45" {...props}>
      <path
        fill={fill}
        d="M39.9997714,-0.0001125 C41.8614857,-0.0001125 43.7232,0.6760125 45.1426286,2.0282625 L77.8694857,33.1817625 C80.7094857,35.8851375 80.7094857,40.2681375 77.8694857,42.9726375 C75.0294857,45.6760125 70.4249143,45.6760125 67.5849143,42.9726375 L39.9997714,16.7140125 L12.4157714,42.9726375 C9.57577143,45.6760125 4.97005714,45.6760125 2.13005714,42.9726375 C-0.709942857,40.2681375 -0.709942857,35.8851375 2.13005714,33.1817625 L34.8569143,2.0282625 C36.2774857,0.6760125 38.1392,-0.0001125 39.9997714,-0.0001125"
        transform="rotate(180 40 22.5)"
      />
    </Icon>
  );
};

CaretDownIcon.propTypes = {
  fill: PropTypes.string,
};

export default CaretDownIcon;
